import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';
import { TemperaturaSelectComponent } from './temperatura-select.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        TemperaturaSelectComponent
    ],
    exports: [
        TemperaturaSelectComponent
    ]
})
export class TemperaturaSelectModule { }
